var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 424,
    viewBox: "0 0 346 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8438 64.6382C56.2243 64.6382 64.6394 56.2232 64.6394 45.8427C64.6394 35.4622 56.2243 27.0472 45.8438 27.0472C35.4634 27.0472 27.0483 35.4622 27.0483 45.8427C27.0483 56.2232 35.4634 64.6382 45.8438 64.6382Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8438 48.0295L45.8572 54.5149L48.2303 54.5014",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.583 56.4003C41.583 56.4003 45.8437 59.7307 50.1044 56.6295",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M296.628 64.6382C307.008 64.6382 315.424 56.2232 315.424 45.8427C315.424 35.4622 307.008 27.0472 296.628 27.0472C286.248 27.0472 277.833 35.4622 277.833 45.8427C277.833 56.2232 286.248 64.6382 296.628 64.6382Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M307.496 41.9326L311.365 47.6764L308.183 49.146",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M301.348 49.6989C301.348 49.6989 304.908 55.1865 310.476 53.2314",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5382 177.897C58.9187 177.897 67.3337 169.482 67.3337 159.102C67.3337 148.721 58.9187 140.306 48.5382 140.306C38.1577 140.306 29.7427 148.721 29.7427 159.102C29.7427 169.482 38.1577 177.897 48.5382 177.897Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5382 177.897C58.9187 177.897 67.3337 169.482 67.3337 159.102C67.3337 148.721 58.9187 140.306 48.5382 140.306C38.1577 140.306 29.7427 148.721 29.7427 159.102C29.7427 169.482 38.1577 177.897 48.5382 177.897Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4077 155.192L63.2774 160.949L60.0954 162.419",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6255 164.387C61.0794 168.028 54.8906 163.147 54.8906 163.147C54.8906 163.147 55.2412 168.001 58.4097 169.969",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M195.506 160.936L192.499 156.487C191.834 151.811 189.432 147.558 185.77 144.576C182.108 141.594 177.457 140.102 172.744 140.397C168.03 140.692 163.602 142.754 160.341 146.17C157.08 149.586 155.227 154.106 155.151 158.827C155.076 163.549 156.783 168.126 159.932 171.645C163.081 175.164 167.442 177.367 172.143 177.813C176.844 178.26 181.541 176.917 185.297 174.054C189.052 171.191 191.59 167.017 192.405 162.366L195.506 160.936Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M181.173 162.958C181.173 162.958 185.663 168.432 191.232 166.477",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M313.928 165.493C312.465 165.74 310.965 165.658 309.537 165.252C308.11 164.846 306.791 164.127 305.676 163.147C305.676 163.147 304.827 167.879 309.047 169.511",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M320.898 160.936L317.892 156.487C317.227 151.811 314.824 147.558 311.162 144.576C307.501 141.594 302.849 140.102 298.136 140.397C293.423 140.692 288.994 142.754 285.734 146.17C282.473 149.586 280.62 154.106 280.544 158.827C280.468 163.549 282.175 168.126 285.325 171.645C288.474 175.164 292.834 177.367 297.535 177.813C302.237 178.26 306.934 176.917 310.689 174.054C314.445 171.191 316.983 167.017 317.797 162.366L320.898 160.936Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8419 291.154C56.2224 291.154 64.6374 282.739 64.6374 272.359C64.6374 261.978 56.2224 253.563 45.8419 253.563C35.4614 253.563 27.0464 261.978 27.0464 272.359C27.0464 282.739 35.4614 291.154 45.8419 291.154Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5825 282.916C41.5825 282.916 45.8432 286.246 50.1039 283.145",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8433 274.541V281.026L48.2298 281.013",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6521 278.399C42.8786 278.399 44.6835 276.594 44.6835 274.368C44.6835 272.141 42.8786 270.336 40.6521 270.336C38.4256 270.336 36.6206 272.141 36.6206 274.368C36.6206 276.594 38.4256 278.399 40.6521 278.399Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9939 278.399C53.2204 278.399 55.0253 276.594 55.0253 274.368C55.0253 272.141 53.2204 270.336 50.9939 270.336C48.7673 270.336 46.9624 272.141 46.9624 274.368C46.9624 276.594 48.7673 278.399 50.9939 278.399Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6836 274.368H46.9488",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M171.614 291.156C181.994 291.156 190.409 282.741 190.409 272.36C190.409 261.98 181.994 253.565 171.614 253.565C161.233 253.565 152.818 261.98 152.818 272.36C152.818 282.741 161.233 291.156 171.614 291.156Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M166.424 278.401C168.651 278.401 170.455 276.596 170.455 274.369C170.455 272.143 168.651 270.338 166.424 270.338C164.198 270.338 162.393 272.143 162.393 274.369C162.393 276.596 164.198 278.401 166.424 278.401Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M176.751 278.401C178.977 278.401 180.782 276.596 180.782 274.369C180.782 272.143 178.977 270.338 176.751 270.338C174.524 270.338 172.719 272.143 172.719 274.369C172.719 276.596 174.524 278.401 176.751 278.401Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M170.454 274.369H172.719",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M167.744 283.147C167.744 283.147 172.8 287.043 179.596 281.69C179.596 281.69 178.248 288.553 171.614 287.866",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M171.614 274.542V281.028L174 281.014",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M315.789 271.522C315.789 271.792 315.789 272.075 315.789 272.358C315.79 276.968 314.096 281.417 311.029 284.86C307.963 288.302 303.739 290.498 299.159 291.029C294.58 291.56 289.965 290.39 286.193 287.741C282.42 285.092 279.752 281.148 278.697 276.66C277.642 272.173 278.273 267.454 280.47 263.401C282.667 259.348 286.277 256.244 290.613 254.679C294.95 253.114 299.71 253.198 303.989 254.913C308.268 256.629 311.767 259.858 313.821 263.985",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M307.875 268.449L311.744 274.193L308.562 275.662",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M301.281 277.01C302.933 278.174 304.848 278.906 306.854 279.141C308.86 279.377 310.893 279.108 312.769 278.359",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M313.727 272.076C315.954 272.076 317.759 270.271 317.759 268.044C317.759 265.818 315.954 264.013 313.727 264.013C311.501 264.013 309.696 265.818 309.696 268.044C309.696 270.271 311.501 272.076 313.727 272.076Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M303.615 272.534C305.841 272.534 307.646 270.729 307.646 268.503C307.646 266.276 305.841 264.471 303.615 264.471C301.388 264.471 299.583 266.276 299.583 268.503C299.583 270.729 301.388 272.534 303.615 272.534Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M309.373 268.503H307.66",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9729 376.691C65.9729 376.961 65.9729 377.244 65.9729 377.527C65.9731 382.137 64.2791 386.586 61.213 390.029C58.1468 393.471 53.9224 395.667 49.3431 396.198C44.7638 396.73 40.1489 395.559 36.3762 392.91C32.6034 390.261 29.9358 386.317 28.8807 381.83C27.8257 377.342 28.4567 372.623 30.6538 368.57C32.8509 364.517 36.4608 361.413 40.7971 359.849C45.1334 358.284 49.8936 358.367 54.1724 360.083C58.4513 361.798 61.9504 365.027 64.0043 369.154",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9099 377.245C66.1364 377.245 67.9413 375.44 67.9413 373.213C67.9413 370.987 66.1364 369.182 63.9099 369.182C61.6834 369.182 59.8784 370.987 59.8784 373.213C59.8784 375.44 61.6834 377.245 63.9099 377.245Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7976 377.703C56.0241 377.703 57.829 375.898 57.829 373.672C57.829 371.445 56.0241 369.64 53.7976 369.64C51.5711 369.64 49.7661 371.445 49.7661 373.672C49.7661 375.898 51.5711 377.703 53.7976 377.703Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5551 373.672H57.8428",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0586 373.617L61.9283 379.375L58.7462 380.844",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2763 382.813C59.7303 386.453 53.5415 381.573 53.5415 381.573C53.5415 381.573 53.8921 386.426 57.0606 388.395",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M176.858 382.18C178.51 383.343 180.425 384.075 182.431 384.311C184.437 384.546 186.47 384.277 188.346 383.528",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M194.157 379.363L191.15 374.913C190.485 370.238 188.082 365.985 184.421 363.002C180.759 360.02 176.108 358.528 171.394 358.823C166.681 359.119 162.253 361.18 158.992 364.596C155.731 368.012 153.878 372.532 153.802 377.254C153.726 381.976 155.433 386.552 158.583 390.071C161.732 393.59 166.092 395.793 170.794 396.239C175.495 396.686 180.192 395.344 183.948 392.481C187.703 389.617 190.241 385.444 191.056 380.792L194.157 379.363Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M186.067 377.703C188.294 377.703 190.099 375.898 190.099 373.672C190.099 371.445 188.294 369.64 186.067 369.64C183.841 369.64 182.036 371.445 182.036 373.672C182.036 375.898 183.841 377.703 186.067 377.703Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M190.908 373.672H190.112",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M165.91 373.82H182.036",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M319.551 379.363L316.544 374.913C315.879 370.238 313.477 365.985 309.815 363.002C306.153 360.02 301.502 358.528 296.789 358.823C292.075 359.119 287.647 361.18 284.386 364.596C281.125 368.012 279.272 372.532 279.196 377.254C279.12 381.976 280.827 386.552 283.977 390.071C287.126 393.59 291.486 395.793 296.188 396.239C300.889 396.686 305.586 395.344 309.342 392.481C313.097 389.617 315.635 385.444 316.45 380.792L319.551 379.363Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M311.461 377.703C313.688 377.703 315.493 375.898 315.493 373.672C315.493 371.445 313.688 369.64 311.461 369.64C309.235 369.64 307.43 371.445 307.43 373.672C307.43 375.898 309.235 377.703 311.461 377.703Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M316.301 373.672H315.506",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M291.304 373.82H307.43",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M312.58 383.919C311.117 384.166 309.617 384.084 308.19 383.678C306.762 383.272 305.443 382.553 304.329 381.573C304.329 381.573 303.479 386.305 307.7 387.937",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M171.235 64.6382C181.615 64.6382 190.03 56.2232 190.03 45.8427C190.03 35.4622 181.615 27.0472 171.235 27.0472C160.854 27.0472 152.439 35.4622 152.439 45.8427C152.439 56.2232 160.854 64.6382 171.235 64.6382Z",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M167.38 56.6292C167.38 56.6292 172.436 60.5258 179.218 55.173C179.218 55.173 177.87 62.036 171.236 61.3483",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M171.236 48.0247V54.5101L173.622 54.4966",
    stroke: "#082C4E",
    strokeWidth: 1.34831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadBase);
export default __webpack_public_path__ + "static/media/head-base.6c3f927b051695b6d28b582eb0595c76.svg";
export { ForwardRef as ReactComponent };